import {
  Box,
  Button,
  CircularProgress,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { Alert } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseURL } from "../../Config/config";
import SelexSolNavbar from "../CommonC/SelexSolNavbar";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");

  const [state, setState] = React.useState({
    isOpen: false,
    vertical: "top",
    horizontal: "center",
  });

  const { vertical, horizontal, isOpen } = state;

  const handleSnackbar = (value) => {
    setState({ ...state, isOpen: value });
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      let result = await fetch(`${baseURL}/resetpassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          reset: "false",
          userType: "users",
        }),
      });

      result = await result.json();
      setSnackbarMessage(result.message);
      handleSnackbar(true);
    } catch (error) {
      setSnackbarMessage("Something went wrong");
      handleSnackbar(true);
    }

    setLoading(false);
  };

  const handlePasswordSubmit = async () => {
    if (password !== confirmPassword) {
      setSnackbarMessage("Password and confirm password are not same");
      handleSnackbar(true);
      return;
    }

    setLoading(true);

    try {
      let result = await fetch(`${baseURL}/resetpassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          password,
          id,
          reset: "true",
          userType: "users",
        }),
      });

      result = await result.json();
      setSnackbarMessage(result.message);
      handleSnackbar(true);

      if (result.code) {
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      }
    } catch (error) {
      setSnackbarMessage("Something went wrong");
      handleSnackbar(true);
    }

    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#eef3f8",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")} />

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={isOpen}
        autoHideDuration={4000}
        onClose={() => handleSnackbar(false)}
      >
        <Alert severity="info" sx={{ fontSize: "12px" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mt: 15,
          position: "relative",
          zIndex: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: 30,
            mb: 3,
            fontWeight: 950,
            color: "#0078c9",
            letterSpacing: "-1.8px",
            lineHeight: 1.08,
          }}
        >
          {!id ? "Forgot Password" : "Reset Password"}
        </Typography>

        <Box
          sx={{
            width: 420,
            background: "#ffffff",
            borderRadius: "14px",
            padding: "52px",
            boxShadow: "0 12px 35px rgba(0,0,0,0.12)",
          }}
        >
          {!id ? (
            <>
              <Typography sx={{ fontSize: 12, mb: 1, color: "#6b7280", letterSpacing: "1px" }}>
                EMAIL OR USERNAME
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", borderBottom: "1px solid #d1d5db", mb: 4, mt: 2 }}>
                <PersonOutlineIcon sx={{ fontSize: 18, color: "#9ca3af", mr: 1 }} />
                <TextField
                  fullWidth
                  variant="standard"
                  placeholder="admin@selexsuite.com"
                  onChange={(e) => setUsername(e.target.value)}
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ style: { fontSize: 16 } }}
                />
              </Box>

              <Button fullWidth onClick={handleSubmit} sx={buttonStyle}>
                {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Submit"}
              </Button>
            </>
          ) : (
            <>
              <Typography sx={{ fontSize: 12, mb: 1, color: "#6b7280", letterSpacing: "1px" }}>
                NEW PASSWORD
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", borderBottom: "1px solid #d1d5db", mb: 3, mt: 2 }}>
                <LockOutlinedIcon sx={{ fontSize: 18, color: "#9ca3af", mr: 1 }} />
                <TextField
                  fullWidth
                  type="password"
                  variant="standard"
                  placeholder="Enter new password"
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ style: { fontSize: 16 } }}
                />
              </Box>

              <Typography sx={{ fontSize: 12, mb: 1, color: "#6b7280", letterSpacing: "1px" }}>
                CONFIRM PASSWORD
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", borderBottom: "1px solid #d1d5db", mb: 4, mt: 2 }}>
                <LockOutlinedIcon sx={{ fontSize: 18, color: "#9ca3af", mr: 1 }} />
                <TextField
                  fullWidth
                  type="password"
                  variant="standard"
                  placeholder="Confirm password"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handlePasswordSubmit()}
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ style: { fontSize: 16 } }}
                />
              </Box>

              <Button fullWidth onClick={handlePasswordSubmit} sx={buttonStyle}>
                {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Reset Password"}
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const buttonStyle = {
  height: 48,
  borderRadius: "8px",
  background: "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
  color: "#fff",
  fontWeight: 600,
  letterSpacing: "1px",
  textTransform: "uppercase",
  boxShadow: "0 6px 15px rgba(0,0,0,0.15)",
  ":hover": {
    background: "linear-gradient(90deg, #095c9c 0%, #1f8bc7 100%)",
  },
};

export default ForgotPassword;